import '../../resources/css/settings/ModalAccountReadyAdd.scss';
import React, { Component } from 'react';
import { Row, Col, Modal, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { popupModalConfirm, closePickModal, savePickModal, MODAL_PICK_SAVE, openModalAlert } from '../../actions/index';
import { doGetAccountApplyList } from '../../actions/settings/index';
import { ReactTabulator } from 'react-tabulator';
import Loading from '../common/Loading';

class ModalAccountReadyAdd extends Component {

    constructor(props) {
        super(props);
    
        this.updateDataList = this.updateDataList.bind(this);
    
        this.state = {
          dataList: false,
          selectDataCount: 0
        }
    }

    ref = null

    updateDataList() {
        const {accountApplyList} = this.props;
        const dataList = (accountApplyList) ? accountApplyList : false;
        this.setState({
            dataList: dataList
        });
    }

    readyToAdd = () => {
        const { popupModalConfirm, modalPick, savePickModal, closePickModal } = this.props;

        const selectData = this.ref.table.getSelectedData();
        if (selectData.length > 0) {
            popupModalConfirm('Confirm', 'icon-alert', 'Confirm to add?', 300, () => {
                let checked = [];
                
                selectData.forEach(data => {
                    checked.push({
                        firstName: data.firstName,
                        lastName: data.lastName,
                        email: data.email,
                        company: data.company,
                        jobTitle: data.jobTitle,
                        systemIntegrator: data.systemIntegrator,
                        internetProvider: data.internetProvider,

                        // inputUsername: data.inputUsername,
                        // inputLoginEmail: data.inputLoginEmail,
                        // inputPassword: data.inputPassword,
                        // inputPasswordConfirm: data.inputPasswordConfirm,
                        // enabled: data.enabled
                    });
                })
                
                savePickModal(modalPick.modalStatus, modalPick.modalAction, checked, MODAL_PICK_SAVE, () => closePickModal(null));
            }, null, false);
        }
        else {
            const { openModalAlert } = this.props
            openModalAlert("Please select account.");
        }
    }

    updateSelectCountState = (selectCount) => {
        this.setState({
            selectDataCount: selectCount
        });
    }

    renderTable = () => {
        const { dataList } = this.state;
        const { updateSelectCountState } = this;

        if (dataList) {
            const options = {
            movableRows: false,
            rowSelectionChanged: function(e, row) {
                updateSelectCountState(row.length);
            },
            };

            return (
            <ReactTabulator
                ref={ref => (this.ref = ref)}
                columns={[
                // { title: "Username", field: "inputUsername" },
                // { title: "Email", field: "inputLoginEmail" },
                // { title: "Password", field: "inputPassword" },
                // { title: "Confirm Password", field: "inputPasswordConfirm" },
                // { title: "Agreement", field: "enabled" },

                { title: "First Name", field: "firstName" },
                { title: "Last Name", field: "lastName" },
                { title: "Email", field: "email" },
                { title: "Company", field: "company" },
                { title: "Job Title", field: "jobTitle" },
                { title: "System Integrator", field: "systemIntegrator" },
                { title: "Internet Provider", field: "internetProvider" },
                {
                    formatter: "rowSelection",
                    title: "Add", 
                    field: "buttonGroup", 
                    width: 120, 
                    // hozAlign:"center", 
                    headerSort:false, 
                    cellClick: function(e, cell){
                    cell.getRow().toggleSelect();
                    },
                }
                ]}
                data={dataList}
                placeholder="No data found"
                options={options}
                className="custom-list-table"
            />
            )
        } else {
            return (
            <Loading loading={true}></Loading>
            )
        }
    }

    renderTableFooter = () => {
        const {accountApplyList} = this.props
        const {selectDataCount} = this.state
        if (accountApplyList) {
            return <span>{selectDataCount} of {accountApplyList.length} selected</span>
        }
    }    

    deleteSelectAll = () => {
        this.ref.table.deselectRow();
    }

    selectAll = () => {
        this.ref.table.selectRow();
    }

    componentDidUpdate (prevProps, prevState, snapshot) {
        // if props change will call this method
        const { accountApplyList } = this.props
        if (prevProps.accountApplyList !== accountApplyList) {
            this.updateDataList();
        }
    }

    componentDidMount () {
        const { authToken, doGetAccountApplyList } = this.props;
        doGetAccountApplyList(authToken);
    }

    render() {
        const { modalPick, closePickModal } = this.props;    
        const show = modalPick.modalStatus === 'settingsAccountReadyAdd';
        let classModal = 'modal-account-ready-add-detail';
        let renderContent;
        if (show) {
            let headerTitle = "Confirm to add account";

            renderContent = (
                <Modal
                    show={show}
                    dialogClassName={ classModal }
                    centered
                    onHide={() => closePickModal(null)}
                >
                    <Modal.Body>
                        <div className='area-modal-detail-header'>
                            <Row>
                                <Col sm={6}>
                                    <span className='header-title'>{ headerTitle }</span>
                                </Col>
                                <Col sm={6} className='area-close-btn'>
                                    <span className='icon-close-detail' onClick={() => closePickModal(null)}><span className="icon-btn-close-n"></span></span>
                                </Col>
                            </Row>
                        </div>
                        <div className='area-modal-detail-content'>
                            {/* { this.renderTableHeader() } */}
                            <div className="area-row-select">
                                <span className='href-class' onClick={this.deleteSelectAll}>Deselect All</span>
                                &nbsp;&nbsp;&nbsp;
                                <span className='href-class' onClick={this.selectAll}>Select All</span>
                            </div>
                            <div className='area-picup-list'>
                                { this.renderTable() }
                            </div>
                            <div className="area-table-footer">
                                { this.renderTableFooter() }
                            </div>
                            <div className='area-btn'>
                                <Button type="button" variant="primary" className='btn-save' onClick={ this.readyToAdd } block>Confirm to add</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            )        
        } else {
            renderContent = (<div className='modal-detail-empty'></div>);
        }

        return (
            <div className='area-account-to-add-detail'>
                {renderContent}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        authToken: state.loginReducers.authToken,
        modalPick: state.commonReducers.modalPick,
        accountApplyList: state.settingsReducers.accountApplyList
    }
}

export default connect(
    mapStateToProps,
    { popupModalConfirm, closePickModal, savePickModal, openModalAlert, doGetAccountApplyList }
)(ModalAccountReadyAdd)